import { defineMessages } from 'react-intl';

export const emrFacilitiesMappingsAlertsMessages = defineMessages({
  // error
  getFacilitiesError: {
    id: 'messages.customerMessages.getFacilitiesError',
    defaultMessage: 'Error getting facilities:',
  },

  // error
  syncFacilityError: {
    id: 'messages.customerMessages.syncFacilityError',
    defaultMessage: 'Could not sync facility',
  },

  // success
  syncFacilitySuccess: {
    id: 'messages.customerMessages.syncFacilitySuccess',
    defaultMessage: 'Facility started to sync...',
  },

  // error
  mappingFacilitiesError: {
    id: 'messages.customerMessages.mappingFacilitiesError',
    defaultMessage: 'An error occured mapping facilities:',
  },

  // success
  mappingFacilitiesSuccess: {
    id: 'messages.customerMessages.mappingFacilitiesSuccess',
    defaultMessage: 'Facilities mapped succesfully',
  },

  // error
  onboardFacilityError: {
    id: 'messages.customerMessages.onboardFacilityError',
    defaultMessage: 'An error occurred onboarding facility:',
  },

  // success
  onboardFacilitySuccess: {
    id: 'messages.customerMessages.onboardFacilitySuccess',
    defaultMessage: 'Facility onboard successfully',
  },

  // error
  onboardPatientsError: {
    id: 'messages.customerMessages.onboardPatientsError',
    defaultMessage: 'An error occurred onboarding patients:',
  },

  // success
  onboardPatientsSuccess: {
    id: 'messages.customerMessages.onboardPatientsSuccess',
    defaultMessage: 'Patients onboarded successfully',
  },
});
